const theme = {
    primaryBackgroundColor: '#373737',
    secondaryBackgroundColor: '#CC3E2B',
    mainBackgroundColor: '#E3E5E8',
    primaryTextColor: '#fff',
    secondaryTextColor: '#373737',
    modalBackgroundColor: 'rgba(0,0,0,0.3)',
    inputLabels: '#373737',
    errorText: 'rgba(255,0,0, 0.6)',
    button: {
        primary: 'linear-gradient(0deg, #b03721 1%, #d63d22 100% )',
        secondary: 'linear-gradient(0deg, #8c8785 2%, #e0d6d1 100% )',
        primaryActive: '#e04533',
        secondaryActive: '#BDBDBD'
    },
    rows: 'linear-gradient(0deg, #ebebeb 1%, #c2bebe 100% )'
};

export default theme;



// WEBPACK FOOTER //
// ./src/lib/theme.js